import {api} from '../helpers/api';
import utils from '../helpers/utils';

export const HOMEPROPERTIES_GET_REQUEST_INITIATE = 'HOMEPROPERTIES_GET_REQUEST_INITIATE';
export const HOMEPROPERTIES_GET_REQUEST_SUCCESS = 'HOMEPROPERTIES_GET_REQUEST_SUCCESS';
export const HOMEPROPERTIES_GET_REQUEST_FAILURE = 'HOMEPROPERTIES_GET_REQUEST_FAILURE';

export function homePropertiesGetRequestInitiate() {
  return {
    type: HOMEPROPERTIES_GET_REQUEST_INITIATE,
  };
}

export function homePropertiesGetRequestSuccess(payload: $TSFixMe) {
  return {
    type: HOMEPROPERTIES_GET_REQUEST_SUCCESS,
    properties: payload.propertyList,
  };
}

export function homePropertiesGetRequestFailure(error: $TSFixMe) {
  return {
    type: HOMEPROPERTIES_GET_REQUEST_FAILURE,
    error,
  };
}

export function getHomeProperties() {
  const url = utils.getHomePropertiesPath();
  const config: FetchConfig = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  };
  return api(
    url,
    config,
    homePropertiesGetRequestInitiate(),
    homePropertiesGetRequestSuccess,
    homePropertiesGetRequestFailure
  );
}
